import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Caso de sessão expirada
          this.handleUnauthorized();
        } else if (error.status === 0) {
          // Caso de conexão recusada ou API indisponível
          this.handleConnectionRefused();
        }
        return throwError(() => error);
      })
    );
  }

  private handleUnauthorized() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
    Swal.fire({
      title: 'Sessão expirada',
      text: 'Faça login novamente.',
      icon: 'warning',
      confirmButtonText: 'Ok',
    });
  }

  private handleConnectionRefused() {
    Swal.fire({
      title: 'Erro de conexão',
      text: 'Não foi possível se conectar ao servidor. Tente novamente mais tarde.',
      icon: 'error',
      confirmButtonText: 'Ok',
    }).then(() => {
      localStorage.removeItem('currentUser');
      this.router.navigate(['/login']);
    });
  }
}
